export const painContinuousText = {
  values: [
    { value: 'Y', text: 'Smerten er kontinuerlig', score: 0 },
    { value: 'N', text: 'Smerten er av og på', score: 0 },
  ],
};
